import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '@zz2/zz2-ui';
import { IDeduction } from '../../@types/model/deductions/deduction';

export default class DeductionActions {
    public static setIsLoading = createAction('DEDUCTION_SET_LOADING', withPayloadType<boolean>());
    public static setDeductionData = createAction('DEDUCTION_SET_LIST', withPayloadType<Array<IDeduction> | null>());
    public static reset = createAction('DEDUCTION_RESET');
}